// IMPORT REACT 
import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';

// IMPORT COMPONENTS
import YALogo from '../../components/Logo';
import YADropdown from '../../components/Dropdown';
import YAButton from '../../components/Form/Button';

// IMPORT IMAGES/STYLES
import {
	SC_Navbar,
	SC_NavbarBrand,
	SC_NavbarBrandDivider,
	SC_NavbarToggler,
	SC_NavbarTogglerIcon,
	SC_NavbarCollapse,
	SC_NavbarNav,
	SC_NavItem,
	SC_Link,
	SC_NavLink,
	SC_Button
} from './styles';

class YANavbar extends React.Component {

	state = {
		pages: null,
		languages: null,
		collapseOpen: false,
		user: null
	};

	componentDidMount() {
		const lang = this.props.lang;
		const page = this.props.page;
		if (lang) {
			const pages = this.getNavPages('home,faqs,login,resources', lang).then(data => {
				this.setState({ pages: data });
			});
		}
		if (page) {
			this.getLangToggle().then(data => {
				let languages = [];
				data.map((langdata) => {
					this.getNavPages(page.post_name, langdata.slug).then(pagedata => {
						languages.push({
							name: langdata.name,
							slug: langdata.slug,
							page_permalink: pagedata ? pagedata[0].permalink : '/home/'
						});
						this.setState({ languages: languages });
					});
				})
			})
		}
		this.getUser(lang).then(data => {
			this.setState({
				user: data
			});
		});
	}

	getUser(lang) {
		let url = '/wp-json/wp/v2/weemarkable/user/';
		url += '?lang=';
		url += lang;
		return Axios({
			method: 'get',
			url: url,
			headers: {
				// eslint-disable-next-line no-undef
				'X-WP-Nonce': frontend_ajax_object.nonce
			},
		}).then((response) => {
			return response.data;
		}).catch(function (error) {
			console.log(error, 'Error');
		});
	}

	getLangToggle() {
		let url = '/wp-json/wp/v2/weemarkable/languages/';
		return Axios({
			method: 'get',
			url: url,
			headers: {
				// eslint-disable-next-line no-undef
				'X-WP-Nonce': frontend_ajax_object.nonce
			},
		}).then((response) => {
			if (response.data[0]) {
				return response.data;
			} else {

				console.log(response, 'Error');
			}
		}).catch(function (error) {
			console.log(error, 'Error');
		});
	}

	getNavPages(page_name, lang) {
		let url = '/wp-json/wp/v2/weemarkable/pages/';
		url += '?post_type=page&post_name=';
		url += page_name;
		url += '&lang=';
		url += lang;
		return Axios({
			method: 'get',
			url: url,
			headers: {
				// eslint-disable-next-line no-undef
				'X-WP-Nonce': frontend_ajax_object.nonce
			},
		}).then((response) => {
			if (response.data[0]) {
				return response.data;
			} else {
				console.log(response, 'Error');
			}
		}).catch(function (error) {
			console.log(error, 'Error');
		});
	}

	render() {
		const lang = this.props.lang;
		const pages = this.state.pages;
		const languages = this.state.languages;
		let collapseOpen = this.state.collapseOpen;
		let user = this.state.user;

		let home;
		let faqs;
		let login;
		let resources;

		if (pages) {
			home = pages[0];
			faqs = pages[1];
			login = pages[2];
			resources = pages[3]; // doesn't exist if not logged in
		}

		let languageToggle;
		if (languages) {
			languageToggle = languages.map((data) => {
				return (
					<SC_NavItem key={data.slug}>
						<SC_NavLink exact to={data.page_permalink}>
							{data.name}
						</SC_NavLink>
					</SC_NavItem>
				);
			});
		}

		return (
			<SC_Navbar>

				<SC_NavbarBrand>
					<Link to={pages ? home.permalink : '#'}>
						<YALogo brand="ymca-icon" margin={["navbarPaddingY", "navbarPaddingY"]} />
						<SC_NavbarBrandDivider />
						<YALogo brand="weemarkable" margin={["navbarPaddingY", "navbarPaddingY"]} />
					</Link>
				</SC_NavbarBrand>

				<SC_NavbarToggler aria-label="Toggle Navigation" onClick={(e) => {
					e.preventDefault();
					this.setState({
						collapseOpen: !collapseOpen
					})
				}}
					aria-expanded={collapseOpen}>
					<SC_NavbarTogglerIcon />
				</SC_NavbarToggler>

				<SC_NavbarCollapse className={collapseOpen ? 'show' : null}>
					<SC_NavbarNav align="center">

						<SC_NavItem>
							<SC_NavLink exact to={pages ? home.permalink : '#'}>
								{pages ? home.post_title : null}
							</SC_NavLink>
						</SC_NavItem>
						<SC_NavItem>
							<SC_NavLink to={pages ? faqs.permalink : '#'}>
								{pages ? faqs.post_title : null}
							</SC_NavLink>
						</SC_NavItem>
						<YADropdown toggleText={pages ? home.meta.page_header_download : null} items={pages ? [
							{
								href: home.meta.page_header_download_apple_link,
								icon: "apple",
								text: home.meta.page_header_download_apple
							},
							{
								href: home.meta.page_header_download_android_link,
								icon: "google-play",
								text: home.meta.page_header_download_android
							}
						] : []} />
					</SC_NavbarNav>

					<SC_NavbarNav>
						<SC_NavItem>
							{user && user.user && user.user.ID ?
								<YAButton color="outline-light" loading={!pages ? 'true' : null} onClick={(e) => {
									e.preventDefault();
									window.location = user.logout_url;
								}}>
									{pages ? login.meta.logout : '...'}
								</YAButton>
								:
								<SC_Button loading={!pages ? 'true' : null} to={pages ? login.permalink : '#'}>
									{pages ? login.post_title : '...'}
								</SC_Button>
							}

						</SC_NavItem>

					</SC_NavbarNav>
				</SC_NavbarCollapse>



			</SC_Navbar>
		)
	}

}
export default YANavbar;